import React, { memo, useCallback, useState } from "react";
import clsx from "clsx";
import { useCarConfigSelector } from "../../../../redux/store";
import styles from "./Summary.module.scss";
import Text from "../../../../../shared-components/css-modules/lexus/atoms/Text";
import Button from "../../../../../shared-components/css-modules/lexus/atoms/Button";
import Modal from "../../../../../shared-components/css-modules/lexus/organisms/Modal";
import SummarySimilarCars from "./SummarySimilarCars";
import ETA from "./ETA";
import Icon from "../../../../../shared-components/css-modules/lexus/atoms/Icon";
import { CarConfigLabel } from "../../../../utils/labelUtils";

const SummaryEta = (): JSX.Element | null => {
    const date = useCarConfigSelector((state) => state.eta.date);
    const alternatives = useCarConfigSelector((state) => state.eta.alternatives);
    const [similarCarsOpen, setSimilarCarsOpen] = useState<boolean>(false);

    const onSimilarCarsClick = useCallback(() => {
        setSimilarCarsOpen(true);
    }, []);

    const onSimilarCarsClose = useCallback(() => {
        setSimilarCarsOpen(false);
    }, []);

    if (!date) return null;

    return (
        <>
            <div className={clsx(styles.card, styles["config-subitem"], styles["config-subitem-eta"])}>
                <div className={styles["config-subitem-title"]}>
                    <Text tag="h4" variant="apheleia-h6" className={styles["config-subitem-title-eta"]}>
                        <Icon variant="calendar" sizing="sm" aria-hidden="true" />
                        <CarConfigLabel label="carConfigDelivery" />
                    </Text>
                </div>
                <div className={styles["config-subitem-price"]}>
                    <Text variant="apheleia-h6" className={styles["config-subitem-price"]}>
                        <ETA date={date} />
                    </Text>
                </div>
                {alternatives.length !== 0 && (
                    <div className={styles["config-subitem-cta"]}>
                        <Button variant="apheleia-text" onClick={onSimilarCarsClick}>
                            <CarConfigLabel label="carConfigSimilarCars" />
                        </Button>
                    </div>
                )}
            </div>
            {alternatives.length !== 0 && (
                <Modal open={similarCarsOpen} onRequestClose={onSimilarCarsClose}>
                    <SummarySimilarCars />
                </Modal>
            )}
        </>
    );
};

export default memo(SummaryEta);
